export enum TableName {
  TABLE_ROLE = 'TABLE_ROLE',
  TABLE_USER = 'TABLE_USER',
  TABLE_DEPARTMENT = 'TABLE_DEPARTMENT',
  TABLE_MENU = 'TABLE_MENU',
  TABLE_COMMISSION = 'TABLE_COMMISSION',
  TABLE_COSTTYPE = 'TABLE_COSTTYPE',
  TABLE_TICKETTITLE = 'TABLE_TICKETTITLE',
  TABLE_PAYMENTACCOUNT = 'TABLE_PAYMENTACCOUNT',
  TABLE_CUSTOMRLEVEL = 'TABLE_CUSTOMRLEVEL',
  TABLE_MATERIALUNIT = 'TABLE_MATERIALUNIT',
  TABLE_SYSAREA = 'TABLE_SYSAREA',
  TABLE_CUSTOMERSOURCE = 'TABLE_CUSTOMERSOURCE',
  TABLE_PAYMENTCYCLE = 'TABLE_PAYMENTCYCLE',
  TABLE_PURCHASEPAYCYCLE = 'TABLE_PURCHASEPAYCYCLE',

  TABLE_URGENCY = 'TABLE_URGENCY',
  TABLE_INDUSTRY = 'TABLE_INDUSTRY',
  TABLE_COMPANYTYPE = 'TABLE_COMPANYTYPE',
  TABLE_BUSINESSCLASS = 'TABLE_BUSINESSCLASS',

  TABLE_CUSTOMERCOMPANY = 'TABLE_CUSTOMERCOMPANY',
  TABLE_CUSTOMERCONTACT = 'TABLE_CUSTOMERCONTACT', // 客户联系人
  TABLE_CUSTOMERTICKETTITLE = 'TABLE_CUSTOMERTICKETTITLE', // 客户开票信息
  TABLE_CUSTOMERCONTACTPAY = 'TABLE_CUSTOMERCONTACTPAY', // 客户联系人的付款方式
  TABLE_CUSTOMERPUBLIC = 'TABLE_CUSTOMERPUBLIC', // 公共客户
  TABLE_COSTOMER_TRACE = 'TABLE_COSTOMER_TRACE', // 客户公司日志
  TABLE_OUTSOURCE_COMPANY = 'TABLE_OUTSOURCE_COMPANY', // 外包管理

  TABLE_OUTSOURCE_COMPANY_CONTACT = 'TABLE_OUTSOURCE_COMPANY_CONTACT', // 外包联系人
  TABLE_OUTSOURCE_COMPANY_ACCOUNT = 'TABLE_OUTSOURCE_COMPANY_ACCOUNT', // 外包账户信息
  TABLE_USER_ACCESSLOG = 'TABLE_USER_ACCESSLOG',
  TABLE_USER_OPERATIONLOG = 'TABLE_USER_OPERATIONLOG',
  TABLE_BUSINESS_LIST = 'TABLE_BUSINESS_LIST', // 业务系统
  TABLE_QUOTATION = 'TABLE_QUOTATION', // 报价
  TABLE_REPAIR = 'TABLE_REPAIR', // 维修
  TABLE_MARKET_FEE = 'TABLE_MARKET_FEE', // 市场费
  TABLE_ORDER = 'TABLE_ORDER', // 订单
  TABLE_OUTSOURCE_BUSINESS = 'TABLE_OUTSOURCE_BUSINESS', // 外包业务
  TABLE_OUTSOURCE_BUSINESS_FEE = 'TABLE_OUTSOURCE_BUSINESS_FEE', // 外包费
  TABLE_OUTSOURCE_BUSINESS_FEE_TICKET = 'TABLE_OUTSOURCE_BUSINESS_FEE_TICKET', // 外包费
  TABLE_CANCEL_BUSINESS = 'TABLE_CANCEL_BUSINESS', // 取消业务
  TABLE_QUOTED_BUSINESS = 'TABLE_QUOTED_BUSINESS', // 取消业务
  TABLE_COMPELTETS_BUSINESS = 'TABLE_COMPELTETS_BUSINESS', // 完成业务
  TABLE_ORDERED_BUSINESS = 'TABLE_ORDERED_BUSINESS',
  TABLE_SALES_BUSINESS = 'TABLE_SALES_BUSINESS',
  TABLE_RECEIVED_BUSINESS = 'TABLE_RECEIVED_BUSINESS', // 待首款业务
  TABLE_INVOICE_BUSINESS = 'TABLE_INVOICE_BUSINESS', // 待开票业务
  TABLE_COMFIRM_BUSINESS = 'TABLE_COMFIRM_BUSINESS', // 待确认业务
  TABLE_TO_ORDERED_BUSINESS = 'TABLE_TO_ORDERED_BUSINESS',

  TABLE_QUOTATION_MARK_TEMPLATE = 'TABLE_QUOTATION_MARK_TEMPLATE', // m模版
  TABLE_INVOICE = 'TABLE_INVOICE',
  TABLE_INVOICE_ORDER = 'TABLE_INVOICE_ORDER',

  TABLE_APPROVAL_BUSINESS = 'TABLE_APPROVAL_BUSINESS',
  TABLE_APPROVAL_CANCEL_BUSINESS = 'TABLE_APPROVAL_CANCEL_BUSINESS',
  TABLE_APPROVAL_OUTSOURCE = 'TABLE_APPROVAL_OUTSOURCE', // 外包审批
  TABLE_APPROVAL_OUTSOURCE_COMPANY_ACCOUNT = 'TABLE_APPROVAL_OUTSOURCE_COMPANY_ACCOUNT', // 外包账户信息
  TABLE_APPROVAL_OUTSOURCE_FEE = 'TABLE_APPROVAL_OUTSOURCE_FEE',
  TABLE_APPROVAL_SUPPLIER_ACCOUNT = 'TABLE_APPROVAL_SUPPLIER_ACCOUNT',
  TABLE_APPROVAL_SUPPLIER = 'TABLE_APPROVAL_SUPPLIER',
  TABLE_APPROVAL_PURCHASE = 'TABLE_APPROVAL_PURCHASE', // 采购
  TABLE_APPROVAL_MARKET_FEE = 'TABLE_APPROVAL_MARKET_FEE',
  TABLE_APPROVAL_CUSTOMER = 'TABLE_APPROVAL_CUSTOMER', // 审批客户
  TABLE_APPROVAL_TICKETTITLE = 'TABLE_APPROVAL_TICKETTITLE', // 审批发票
  TABLE_APPROVAL_ORDER = 'TABLE_APPROVAL_ORDER',

  TABLE_CHARGEFEE = 'TABLE_CHARGEFEE', // 收费列表
  TABLE_FINANCIAL_OUTSOURCE_FEE = 'TABLE_FINANCIAL_OUTSOURCE_FEE',
  TABLE_MARKETFEEUSER = 'TABLE_MARKETFEEUSER',
  TABLE_MATERIALCLASS = 'TABLE_MATERIALCLASS', // 物料类别
  TABLE_MATERIALINFO = 'TABLE_MATERIALINFO', // 物料基础信息
  TABLE_INVENTORY_LOCAL = 'TABLE_INVENTORY_LOCAL', // 仓库位置
  TABLE_SUPPLIER = 'TABLE_SUPPLIER', // 供应商
  TABLE_SUPPLIER_CONTACT = 'TABLE_SUPPLIER_CONTACT',
  TABLE_SUPPLIER_ACCOUNT = 'TABLE_SUPPLIER_ACCOUNT',

  TABLE_PURCHASEINADVANCE = 'TABLE_PURCHASEINADVANCE',
  TABLE_MATERIAL_PRICE_INFO = 'TABLE_MATERIAL_PRICE_INFO', // 物料采购信息
  TABLE_PURCHASE = 'TABLE_PURCHASE', // 采购
  TABLE_FINANCIAL_PURCHASE_FEE = 'TABLE_FINANCIAL_PURCHASE_FEE',
  TABLE_PURCHASE_TICKET = 'TABLE_PURCHASE_TICKET',
  TABLE_SHIPPER_INFO = 'TABLE_SHIPPER_INFO', // 发货人信息
  TABLE_EXPRESS_INDFO = 'TABLE_EXPRESS_INDFO', // 快递公司
  TABLE_DELIVERY_INFO = 'TABLE_DELIVERY_INFO',
  TABLE_RECEIVE_INFO = 'TABLE_RECEIVE_INFO',
  TABLE_FEE_RATE = 'TABLE_FEE_RATE',
  TABLE_INVENTORY_LOCAL_MATERIAL = 'TABLE_INVENTORY_LOCAL_MATERIAL',
  TABLE_INVENTORY_LOCAL_HISTORY = 'TABLE_INVENTORY_LOCAL_HISTORY',
  TABLE_PURCHASEDELIVERY = 'TABLE_PURCHASEDELIVERY',
  TABLE_STORAGE_DELIVERY = 'TABLE_STORAGE_DELIVERY',
  TABLE_PURCHASE_MINE = 'TABLE_PURCHASE_MINE',
  TABLE_RUKU = 'TABLE_RUKU',
  TABLE_TICKETDETAIL = 'TABLE_TICKETDETAIL',
  TABLE_NOTICKETDETAIL = 'TABLE_NOTICKETDETAIL',
  TABLE_RECEIVEBUSINESSDETAIL1 = 'TABLE_RECEIVEBUSINESSDETAIL1',
  TABLE_MATERIAL_STORAGE = 'TABLE_MATERIAL_STORAGE',
  TABLE_SUPPLIER_PRICE_INFO = 'TABLE_SUPPLIER_PRICE_INFO',
  TABLE_BUSINESS_CONTACT = 'TABLE_BUSINESS_CONTACT',
  TABLE_RECEIVED_DONE_BUSINESS = 'TABLE_RECEIVED_DONE_BUSINESS'
}

export enum permissionName {
  ROLE = 'ROLE',
  USER = 'USER',
  DEPARTMENT = 'DEPARTMENT',
  MENU = 'MENU',
  COMMISSION = 'COMMISSION',
  COSTTYPE = 'COSTTYPE',
  FEERATE = 'FEERATE',
  TICKETTITLE = 'TICKETTITLE',
  PAYMENTACCOUNT = 'PAYMENTACCOUNT',
  CUSTOMRLEVEL = 'CUSTOMRLEVEL',
  MATERIALUNIT = 'MATERIALUNIT',
  SYSAREA = 'SYSAREA',
  CUSTOMERSOURCE = 'CUSTOMERSOURCE',
  PAYMENTCYCLE = 'PAYMENTCYCLE',
  URGENCY = 'URGENCY',
  INDUSTRY = 'INDUSTRY',
  COMPANYTYPE = 'COMPANYTYPE',
  BUSINESSCLASS = 'BUSINESSCLASS',
  CUSTOMER_INFO = 'CUSTOMER_INFO',
  CUSTOMER_CONTACT = 'CUSTOMER_CONTACT', // 客户联系人
  CUSTOMERTICKETTITLE = 'CUSTOMERTICKETTITLE',
  APPROVAL_CUSTOMER = 'APPROVAL_CUSTOMER',
  CUSTOMERCONTACTPAY = 'CUSTOMERCONTACTPAY',
  APPROVAL_TICKETTITLE = 'APPROVAL_TICKETTITLE',
  COSTOMER_TRACE = 'COSTOMER_TRACE', // 客户公司日志
  OUTSOURCE_COMPANY = 'OUTSOURCE_COMPANY', // 外包管理
  APPROVAL_OUTSOURCE = 'APPROVAL_OUTSOURCE', // 外包审批
  OUTSOURCE_COMPANY_CONTACT = 'OUTSOURCE_COMPANY_CONTACT', // 外包联系人
  OUTSOURCE_COMPANY_ACCOUNT = 'OUTSOURCE_COMPANY_ACCOUNT', // 外包账户信息
  APPROVAL_OUTSOURCE_COMPANY_ACCOUNT = 'APPROVAL_OUTSOURCE_COMPANY_ACCOUNT', // 外包账户信息
  USER_ACCESSLOG = 'USER_ACCESSLOG',
  USER_OPERATIONLOG = 'USER_OPERATIONLOG',
  BUSINESS_LIST = 'BUSINESS_LIST',
  QUOTATION = 'QUOTATION',
  REPAIR = 'REPAIR',
  ORDER = 'ORDER',
  APPROVAL_ORDER = 'APPROVAL_ORDER',
  OUTSOURCE_BUSINESS = 'OUTSOURCE_BUSINESS', // 外包业务
  OUTSOURCE_BUSINESS_FEE = 'OUTSOURCE_BUSINESS_FEE', // 外包费

  SALES_BUSINESS = 'SALES_BUSINESS', // 销售类业务
  RECEIVED_BUSINESS = 'RECEIVED_BUSINESS', // 待首款业务
  INVOICE_BUSINESS = 'INVOICE_BUSINESS', // 待开票业务
  CONFIRM_BUSINESS = 'CONFIRM_BUSINESS', // 待开票业务
  QUOTATION_MARK_TEMPLATE = 'QUOTATION_MARK_TEMPLATE', // m模版
  INVOICE = 'INVOICE',
  INVOICE_ORDER = 'INVOICE_ORDER',
  APPROVAL_OUTSOURCE_FEE = 'APPROVAL_OUTSOURCE_FEE',
  CHARGEFEE = 'CHARGEFEE', // 收费列表
  FINANCIAL_OUTSOURCE_FEE = 'FINANCIAL_OUTSOURCE_FEE',
  MARKETFEEUSER = 'MARKETFEEUSER',
  MATERIALCLASS = 'MATERIALCLASS', // 物料类别
  MATERIALINFO = 'MATERIALINFO', // 物料基础信息
  INVENTORY_LOCAL = 'INVENTORY_LOCAL', // 仓库位置
  SUPPLIER = 'SUPPLIER', // 供应商
  SUPPLIER_CONTACT = 'SUPPLIER_CONTACT', // 供应商
  SUPPLIER_ACCOUNT = 'SUPPLIER_ACCOUNT', // 供应商
  APPROVAL_SUPPLIER_ACCOUNT = 'APPROVAL_SUPPLIER_ACCOUNT', // 供应商
  APPROVAL_SUPPLIER = 'APPROVAL_SUPPLIER', // 供应商
  PURCHASEINADVANCE = 'PURCHASEINADVANCE', // 供应商
  MATERIAL_PRICE_INFO = 'MATERIAL_PRICE_INFO', // 物料采购信息
  PURCHASE = 'PURCHASE', // 采购
  APPROVAL_PURCHASE = 'APPROVAL_PURCHASE',
  FINANCIAL_PURCHASE_FEE = 'FINANCIAL_PURCHASE_FEE',
  PURCHASE_TICKET = 'PURCHASE_TICKET',
  SHIPPER_INFO = 'SHIPPER_INFO',
  EXPRESS_INDFO = 'EXPRESS_INDFO', // 快递公司
  DELIVERY_INFO = 'DELIVERY_INFO',
  RECEIVE_INFO = 'RECEIVE_INFO',
  // LOGISTIC_INFO = 'LOGISTIC_INFO',
  QUOTED_BUSINESS = 'QUOTED_BUSINESS', // 待报价业务
  TO_ORDERED_BUSINESS = 'TO_ORDERED_BUSINESS',
  APPROVAL_MARKET_FEE = 'APPROVAL_MARKET_FEE',
  PURCHASEPAYCYCLE = 'PURCHASEPAYCYCLE',
  PURCHASEDELIVERY = 'PURCHASEDELIVERY',
  STORAGE_DELIVERY = 'STORAGE_DELIVERY',
  PURCHASE_MINE = 'PURCHASE_MINE',
  RUKU = 'RUKU',
  TICKETDETAIL = 'TICKETDETAIL',
  NOTICKETDETAIL = 'NOTICKETDETAIL',
  RECEIVEBUSINESSDETAI1 = 'RECEIVEBUSINESSDETAI1'
}

// paymentAccount/page
// customerLevel/page
// materialUnit/page
// sysArea/
// customerSource/page
// paymentCycle/
// urgency/
// industry/
// companyType/
// customerCompany/
// outsourceCompany/
// outsourceCompanyAccount/page
